import React from 'react';

const MembershipCards = () => {
  const baseFeatures = [
    "CASH BACK rewards",
    "Loan Advisory",
    "Financial Loan Eligibility checks",
    "TFS Special plater (PL/BL/HL/LAP)",
    "Door step services",
];

  const platinumExtraFeatures = [
    "Financial Re-structuring",
    "Loan Conversion consultation",
    "MOE/MODT submission services",
    "Property Investment Advisory",
    "GST Return's Filling - If NILL",
    "Labour License Renewal (Consultant charges NILL)",
    "UDHYAM certificate(Consultant charges NILL)",
    "RTA Hypothication (25% refund or Rs.1000/- whichever is lower)",
    "Free CAR Valuation Services (Buy/Sell)",
    "Document Writer Services"
  ];

  const diamondExtraFeatures = [
    "Land use certificate upto 2 survey No's (NIL Charges)",
    "SRO Related Services",
    "TFS Special services"
  ];

  const plans = [
    {
      name: "TFS GOLD",
      price: "₹299",
      duration: "per year",
      features: baseFeatures,
      subtitle: "Essential Benefits"
    },
    {
      name: "TFS PLATINUM",
      price: "₹499",
      duration: "per year",
      features: [...baseFeatures, ...platinumExtraFeatures],
      subtitle: "All GOLD benefits PLUS",
      extraFeatures: platinumExtraFeatures
    },
    {
      name: "TFS DIAMOND",
      price: "₹999",
      duration: "for 4 years",
      features: [...baseFeatures, ...platinumExtraFeatures, ...diamondExtraFeatures],
      subtitle: "All PLATINUM benefits PLUS",
      extraFeatures: diamondExtraFeatures
    }
  ];

  return (
    <>
      <style>
        {`
          .cards-container {
            max-width: 1200px;
            margin: 0 auto;
            padding: 20px;
          }

          .cards-grid {
            display: grid;
            grid-template-columns: 1fr;
            gap: 24px;
            width: 100%;
          }

          @media (min-width: 768px) {
            .cards-grid {
              grid-template-columns: repeat(2, 1fr);
            }
          }

          @media (min-width: 1024px) {
            .cards-grid {
              grid-template-columns: repeat(3, 1fr);
            }
          }

          .card {
            background: white;
            border-radius: 12px;
            box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
            transition: box-shadow 0.3s ease;
            display: flex;
            flex-direction: column;
            height: 100%;
          }

          .card:hover {
            box-shadow: 0 8px 12px rgba(0, 0, 0, 0.15);
          }

          .card-header {
            background: #2563eb;
            color: white;
            padding: 16px;
            border-radius: 12px 12px 0 0;
            text-align: center;
          }

          .plan-name {
            font-size: 20px;
            font-weight: bold;
            margin: 0;
            color : white;
          }

          .plan-subtitle {
            font-size: 14px;
            margin-top: 6px;
            opacity: 0.9;
          }

          .price-container {
            margin-top: 12px;
          }

          .price {
            font-size: 28px;
            font-weight: bold;
          }

          .duration {
            font-size: 12px;
            margin-left: 4px;
          }

          .card-content {
            padding: 16px;
            flex-grow: 1;
          }

          .features-list {
            list-style: none;
            padding: 0;
            margin: 0;
          }

          .feature-item {
            display: flex;
            align-items: flex-start;
            margin-bottom: 12px;
            color: #4a5568;
            line-height: 1.4;
            font-size: 14px;
          }

          .feature-item.extra {
            background: #f0f9ff;
            padding: 8px;
            border-radius: 6px;
            margin-top: 4px;
          }

          .check-icon {
            min-width: 20px;
            width: 20px;
            height: 20px;
            margin-right: 8px;
            margin-top: 2px;
            flex-shrink: 0;
            color: #22c55e;
          }

          .section-title {
            font-size: 16px;
            font-weight: 600;
            color: #2563eb;
            margin: 16px 0 12px;
            padding-bottom: 8px;
            // border-bottom: 2px solid #e5e7eb;
          }

          .card-footer {
            padding: 16px;
            padding-top: 0;
          }

          .subscribe-button {
            width: 100%;
            padding: 10px 20px;
            background: #2563eb;
            color: white;
            border: none;
            border-radius: 8px;
            font-weight: 600;
            cursor: pointer;
            transition: background-color 0.2s ease;
            font-size: 14px;
          }

          .subscribe-button:hover {
            background: #1d4ed8;
          }
        `}
      </style>

      <div className="cards-container">
        <div className="cards-grid">
          {plans.map((plan, index) => (
            <div key={index} className="card">
              <div className="card-header">
                <h2 className="plan-name">{plan.name}</h2>
                {plan.subtitle && <div className="plan-subtitle">{plan.subtitle}</div>}
                <div className="price-container">
                  <span className="price">{plan.price}</span>
                  <span className="duration">{plan.duration}</span>
                </div>
              </div>
              
              <div className="card-content">
                <ul className="features-list">
                  {index === 0 ? (
                    // Gold plan shows base features
                    plan.features.map((feature, idx) => (
                      <li key={idx} className="feature-item">
                        <svg className="check-icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"
                          strokeLinecap="round" strokeLinejoin="round">
                          <path d="M22 11.08V12a10 10 0 1 1-5.93-9.14"/>
                          <polyline points="22 4 12 14.01 9 11.01"/>
                        </svg>
                        <span>{feature}</span>
                      </li>
                    ))
                  ) : (
                    // Platinum and Diamond plans show previous tier + new features
                    <>
                      <div className="section-title">All {plans[index-1].name} Benefits</div>
                      {/* {plans[index-1].features.map((feature, idx) => (
                        <li key={idx} className="feature-item">
                          <svg className="check-icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"
                            strokeLinecap="round" strokeLinejoin="round">
                            <path d="M22 11.08V12a10 10 0 1 1-5.93-9.14"/>
                            <polyline points="22 4 12 14.01 9 11.01"/>
                          </svg>
                          <span>{feature}</span>
                        </li>
                      ))} */}
                      
                      <div className="section-title">Plus These Benefits</div>
                      {plan.extraFeatures?.map((feature, idx) => (
                        <li key={idx} className="feature-item extra">
                          <svg className="check-icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"
                            strokeLinecap="round" strokeLinejoin="round">
                            <path d="M22 11.08V12a10 10 0 1 1-5.93-9.14"/>
                            <polyline points="22 4 12 14.01 9 11.01"/>
                          </svg>
                          <span>{feature}</span>
                        </li>
                      ))}
                    </>
                  )}
                </ul>
              </div>
            </div>
          ))}
        </div>
      </div>
    </>
  );
};

export default MembershipCards;